import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  AssetTimeBasedMetadataAppState,
  TimebasedMetadataFilters,
} from './types';

const initialState: AssetTimeBasedMetadataAppState = {
  segmentIds: {},
  filteredSegmentsIds: {},
  filters: {},
  loading: {},
};

export const assetTimeBasedMetadataSlice = createSlice({
  name: 'asset_time_based_metadata',
  initialState,
  reducers: {
    assetTimeBasedMetadataLoadingUpdated: (
      state,
      action: PayloadAction<{ assetId: string; loading: boolean }>,
    ) => {
      state.loading[action.payload.assetId] = action.payload.loading;
    },

    assetTimeBasedMetadataReceived: (
      state,
      action: PayloadAction<{ assetId: string; segmentIds: string[] }>,
    ) => {
      const { assetId, segmentIds } = action.payload;
      state.segmentIds[assetId] = Array.from(
        new Set((state.segmentIds[assetId] || []).concat(segmentIds)),
      );
    },

    filteredIdsReceived: (
      state,
      action: PayloadAction<{
        assetId: string;
        filteredIds: string[] | undefined;
      }>,
    ) => {
      const { assetId, filteredIds } = action.payload;
      if (filteredIds === undefined) {
        delete state.filteredSegmentsIds[assetId];
      } else {
        state.filteredSegmentsIds[assetId] = filteredIds;
      }
    },

    setPropertyFilter: (
      state,
      action: PayloadAction<{
        name: keyof TimebasedMetadataFilters;
        value: string[];
      }>,
    ) => {
      state.filters[action.payload.name] = action.payload.value;
    },
  },
});

export const {
  assetTimeBasedMetadataLoadingUpdated,
  assetTimeBasedMetadataReceived,
  filteredIdsReceived,
  setPropertyFilter,
} = assetTimeBasedMetadataSlice.actions;

export const assetTimeBasedMetadataReducer =
  assetTimeBasedMetadataSlice.reducer;
